<template>
    <div>
        <div class="form-item">
            <label class="label"><i class="required">*</i>服务类型认证：</label>
        </div>
        <div class="form-item" v-for="(sItem,sIndex) in secondProductList" :key="sItem.ProductId">
            <label class="label">{{sItem.ProductName}}</label>
            <div class="input-box">
                <template v-if="allTag[sIndex]">
                    <div class="tag-item" v-for="(tItem,tIndex) in allTag[sIndex]" :key="tIndex">
                        {{tItem.chooseText}}
                        <i class="el-icon el-icon-close" @click="removeThreeProductList(sIndex, tIndex)"></i>
                    </div>
                </template>
                <div class="btn-add" @click="showThreeProductList(sIndex)">
                <i class="el-icon el-icon-plus"></i>
                添加
                </div>
            </div>
        </div>
        <my-dialog class="stages-dialog" :show="showStep" titleCenter title="服务类型-认证" @close="showStep=false;">
            <!-- 三级产品 -->
            <block v-if="showStep === 1">
              <ul class="domain-wrapper" >
                  <label class="d-block" v-for="item in threeProductList" :key="'ProductId'+item.ProductId">
                      <input class="radio" type="radio" name="domain" v-model="threeProductChecked" :value="item" />
                      <span class="radio-val">{{item.ProductName}}</span>
                  </label>
              </ul>
              <div class="btn-primary"  @click="confirmThreeProduct">确认</div>
            </block>
            <!-- 服务类型 -->
            <div class="check-wrapper" v-if="showStep === 2">
                <i class="icon-back" @click="showStep=1"></i>
                <ul class="check-list">
                <li v-for="item in serviceStagesList" :key="item.ServiceStageId">
                    <label class="check-item" >
                    <input class="checkbox" type="checkbox" name="stage" v-model="stagesChecked" :value="item" />
                    <span class="text">{{item.ServiceStageName}}</span>
                    </label>
                </li>
                </ul>
                <div class="btn-primary" @click="confirmStages">确认</div>
            </div>
        </my-dialog>
    </div>
</template>
<script>
import Dialog from "@/components/gkDialog.vue";
import { 
  ThreeProductList,
  ServiceStagesByDomain,
} from '@/scripts/api.js'
import {mapState} from 'vuex'


export default({
    components: {
    "my-dialog": Dialog,
  },
    props: {
        ll: {
            type: Boolean,
            value: false
        },
        allTag: {
          type: Array,
          value: []
        }
    },
    computed: {
    ...mapState({
      secondProductList: state => state.secondProductList,
    })
  },
    data() {
        return {
            threeProductChecked: "",
            threeProductList: [],
            showThreeProductStageDialog: false,
            activeIndex1: null,
            activeIndex2: null,
            showStep: null,
            stagesChecked: [],
            stagesAuth: [],
            // allTag: [], // 服务类型认证
        }
    },
    methods: {
        // 新增二级产品、三级产品逻辑 开始
        getThreeProductList(item, index) {
            ThreeProductList({ParentId: item.ProductId}).then(r=>{
                if(r.Result==1){
                    this.threeProductList = r.Data.ProductList;
                    this.secondProductList[index].allThree = r.Data.ProductList;
                    console.log("this.threeProductList",this.threeProductList)
                    console.log("this.secondProductList",this.secondProductList)
                    console.log("this.showThreeProductStageDialog",this.showThreeProductStageDialog)
                }
            })
        },
        removeThreeProductList(sIndex, tIndex){
            let newList = this.allTag[sIndex];
            newList.splice(tIndex,1);
            this.allTag[sIndex] = newList;
            this.onSelectST();
            this.$forceUpdate();
            console.log("allTag",this.allTag)
        },
        resetDialog() {
            this.threeProductChecked = "";
            this.stagesChecked = [];
        },
        showThreeProductList(index) {
            this.resetDialog();
            console.log("this.secondProductList",this.secondProductList, "index", index);

            // 接口请求过得话，不用二次请求
            if(this.secondProductList[index].allThree) {
                this.threeProductList = this.secondProductList[index].threeProductList || this.secondProductList[index].allThree;
            }else {
                this.getThreeProductList(this.secondProductList[index], index);
            }
            this.showThreeProductStageDialog = true;
            this.showStep = 1;
            this.activeIndex1 = index;
            this.showThreeProductStageDialogStep = 1;
        },
        confirmThreeProduct() {
            if(this.threeProductChecked==''){
                return;
            }
            this.activeIndex2 = this.threeProductList.findIndex(item=> item === this.threeProductChecked);

            this.secondProductList[this.activeIndex1].threeProductList = this.threeProductList;
            this.secondProductList[this.activeIndex1].chooseTp = this.activeIndex2;
                ServiceStagesByDomain({
                    ProductDomainId: 0,
                    platform:'pcweb',
                }).then(r=>{
                    if(r.Result==1){
                        this.serviceStagesList=r.Data.Lines;
                        this.showStep=2;
                    }
                });
                console.log("threeProductCheckfed",this.threeProductChecked);

        },
        //添加服务类型
        confirmStages(){
            if(this.stagesChecked.length==0){
                return;
            }
            let allTagText = this.threeProductList[this.activeIndex2].ProductName + "-"
            this.stagesChecked.map(item=>{
                allTagText += item.ServiceStageName + "/"
            })
            let lll = {
                chooseText: allTagText.slice(0,-1),
                chooseList: this.stagesChecked,
                id1: this.secondProductList[this.activeIndex1],
                id2: this.threeProductChecked.ProductId
            };
            let allTag = this.allTag[this.activeIndex1] || [];
            allTag.push(lll)
            this.allTag[this.activeIndex1] = allTag;

            this.onSelectST();
        },
        onSelectST() {
          let serviceStageTagList = [];
            this.allTag.map(item=>{
              if(item) {
                item.map(pTag=>{
                  let mm  = pTag.chooseList.map(cTag=>{
                    return { twoProductId:  pTag.id1.ProductId, threeProductId:  pTag.id2, serviceStageId : cTag.ServiceStageId };
                  })
                  serviceStageTagList = serviceStageTagList.concat(mm)
                })
              }	
            })
          // 提交产品 
          console.log("postParams", serviceStageTagList)
          this.$emit("serviceStageTagList", serviceStageTagList)
          // 数据置空
          this.showStep=false;
          this.resetDialog();
        }
    }
})
</script>
<style lang="scss">
.certificateTag{
  .label{
    text-align: right;
  }
  .tag-item{
    width: 500px;
    min-height: 38px;
    border: 1px solid #e7e7e7;
    padding: 8px 40px;
    background-color: #fff;
    text-align: center;
    font-size: 14px;
    color: #333;
    line-height: 22px;
    margin-bottom: 10px;
    word-break: break-all;
    position: relative;
    &:hover{
      border-color: #f75959;
      .el-icon-close{
        color: #f75959;
      }
    }
  }
  .el-icon-close{
    font-size: 16px;
    font-weight: bold;
    color: #e7e7e7;
    position: absolute;
    right:0;
    top: 0;
    width: 40px;
    text-align: center;
    cursor: pointer;
    line-height: 38px;
  }
  .btn-add{
    width: 100%;
    height: 38px;
    border: 1px solid #e7e7e7;
    padding: 8px 40px;
    background-color: #fff;
    text-align: center;
    font-size: 14px;
    color: #f75959;
    line-height: 22px;
    cursor: pointer;
    .el-icon-plus{
      margin-right:4px;
      font-weight: bold;
    }
    &:hover{
      border-color: #f75959;
    }
  }
  
  .check-wrapper{
    .btn-primary{
      display: block;
      height: 30px;
      line-height: 30px;
      margin: 20px auto 0;
    }
    .check-list{
      overflow: hidden;
      width: 680px;
      height: 320px;
      overflow-y: auto;
      >li{
        float: left;
        margin-right: 10px;
        margin-bottom: 15px;
        &:nth-child(4n){
          margin-right: 0;
        }
      }
    }
    
  }
  .check-item{
    position: relative;
    display: block;
    .checkbox{
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
    .text{
      display: block;
      padding: 0 10px;
      width: 157px;
      overflow: hidden;
      text-align: center;
      height: 40px;
      border: 1px solid #f9f9f9;
      font-size: 14px;
      color: #333;
      line-height: 38px;
      background-color: #f9f9f9;
      border-radius: 2px;
    }
    .checkbox:checked+.text{
      border-color: #f75959;
    }
  }
  .icon-back{
    position: absolute;
    left: 0px;
    top: 0;
    z-index: 2;
    width: 40px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    cursor: pointer;
    &:before{
      content:'';
      display: inline-block;
      width: 10px;
      height: 10px;
      border-left: 1px solid #fff;
      border-bottom: 1px solid #fff;
      transform: rotate(45deg);
    }
  }
  .search-wrapper{
    overflow: hidden;
    margin-bottom: 6px;
    .btn-check-all{
      float: right;
      font-size: 14px;
      color: #666;
      line-height: 30px;
      background-color: transparent;
      margin-left: 10px;
      cursor: pointer;
      }
  }
  .search-box{
    float: left;
    position: relative;
    input{
      width: 280px;
      border: 1px solid #e5e5e5;
      background: #fff;
      padding-left: 35px;
      border-radius: 30px;
      line-height: 30px;
      height: 30px;
      font-size: 14px;
      font-family: "DIN-Regular";
      color: #666;
    }
    .icon-search{
      position: absolute;
      left: 10px;
      top: 4px;
      line-height: 1;
      font-size:18px;
      color: #f75959;
    }
  }
  .btn-text{
    float: left;
    font-size: 14px;
    color: #f75959;
    line-height: 30px;
    background-color: transparent;
    margin-left: 10px;
    cursor: pointer;
  }
  .letter-list{
    overflow: hidden;
    width: 100%;
    margin-bottom: 6px;
    >li{
      float: left;
      margin-right: 6px;
      padding-left: 4px;
      padding-right: 4px;
      line-height: 24px;
      cursor: pointer;
      font-size: 14px;
      color: #333;
      &.on{
        color: #f75959;
      }
      &:hover{
        color: #f75959;
      }
    }
  }
  .btn-primary{
    width: 100px;
    text-align: center;
    display: block;
    height: 30px;
    line-height: 30px;
    margin: 20px auto 0;
  }
}
.stages-dialog{
  .domain-wrapper{
    padding: 30px 0 0;
    text-align: center;
    overflow-y: auto;
    height: 320px;
    .btn-primary{
      height: 30px;
      line-height: 30px;
      margin: 20px auto 0;
    }
    >label{
        float: left;
        margin-right: 10px;
        margin-bottom: 15px;
        &:nth-child(4n){
          margin-right: 0;
        }
      }
  }
  .d-block{
    display: inline-block;
    margin: 0 auto 20px;
    .radio{
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: 157px;
      opacity: 0;
    }
    .radio-val{
      display: block;
      width: 157px;
      height: 40px;
      border: 1px solid #f9f9f9;
      font-size: 14px;
      color: #333;
      line-height: 38px;
      background-color: #f9f9f9;
      border-radius: 2px;
      word-break: break-all;
      overflow: hidden;
    }
    .radio:checked+.radio-val{
      border-color: #f75959;
    }
  }
}
</style>